'use es6';

import { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withSuspensionBanners } from 'ui-suspension-banners-lib';
import { CONTENT_PANE_CLASSNAME, EDIT_PANE_CLASSNAME } from 'ContentEditorUI/constants/dom';
import { openPanel } from 'ContentEditorUI/redux/actions/panelActions';
import { withRouter } from 'react-router-dom';
import { getSmartViewCriterionId } from 'ContentEditorUI/redux/selectors/smartViewSelectors';
import { getIsSmartContentPreview } from 'ContentEditorUI/redux/selectors/iframesSelectors';
import PreloadedIframeProxy from 'ContentEditorUI/components/temp/PreloadedIframeProxytoExtract';
import SkeletonPreviewIframeStyler from 'ContentEditorUI/containers/SkeletonPreviewIframeStyler';
import BlogIframeMessagingAreaContainer from '../../components/BlogIframeMessagingAreaContainer';
import PreviewIframeStylesManager from 'ContentEditorUI/utils/PreviewIframeStylesManager';
import NewBlogVariationWarningBanner from '../../components/NewBlogVariationWarningBanner';
import { getPreviewIframeWrapperElement } from 'ContentEditorUI/lib/layoutDom';
import NewMlangVariantFromMasterWarning from '../../components/NewMlangVariantFromMasterWarning';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const mapStateToProps = state => ({
  selectedSmartRuleId: getSmartViewCriterionId(state),
  isSmartContentPreview: getIsSmartContentPreview(state)
});
const mapDispatchToProps = {
  openPanel
};
class ContentViewContainer extends Component {
  constructor(props) {
    super(props);
    this.messagingAreaWidthChanged = () => {
      this.setState({
        messagingAreaWidthChanged: this.state.messagingAreaWidthChanged + 1
      });
    };
    this.state = {
      messagingAreaWidthChanged: 0
    };
  }
  getPreviewIframeWrapperElement() {
    if (!this.previewIframeWrapperElement) {
      this.previewIframeWrapperElement = getPreviewIframeWrapperElement();
    }
    return this.previewIframeWrapperElement;
  }
  render() {
    const {
      location
    } = this.props;
    let query;
    if (location && location.search) {
      query = new URLSearchParams(location.search);
    }
    return (
      /*#__PURE__*/
      // @bend-expect trellis-tokenized
      _jsx("div", {
        className: `ceui-pane ${CONTENT_PANE_CLASSNAME} flex-container`,
        children: /*#__PURE__*/_jsxs("div", {
          className: `${EDIT_PANE_CLASSNAME}`,
          children: [query && query.has('newBlogVariation') && /*#__PURE__*/_jsx(NewBlogVariationWarningBanner, {}), /*#__PURE__*/_jsx(NewMlangVariantFromMasterWarning, {}), /*#__PURE__*/_jsx(BlogIframeMessagingAreaContainer, {
            iframeWrapperElement: this.getPreviewIframeWrapperElement(),
            onWidthChangeDone: this.messagingAreaWidthChanged
          }), /*#__PURE__*/_jsxs("div", {
            className: "contentEditor-iframe",
            children: [/*#__PURE__*/_jsx("div", {
              className: "contentEditor-moduleHoverMenu"
            }), /*#__PURE__*/_jsx("div", {
              className: "contentEditor-moduleHoverMenu-SmartContent"
            }), /*#__PURE__*/_jsx(PreloadedIframeProxy, {
              proxyTop: true,
              proxyLeft: true,
              proxyRight: true,
              proxyDisplay: true,
              iframeWrapperElement: this.getPreviewIframeWrapperElement(),
              iframeStylesManager: PreviewIframeStylesManager
            }), /*#__PURE__*/_jsx(SkeletonPreviewIframeStyler, {
              iframeWrapperElement: this.getPreviewIframeWrapperElement()
            })]
          })]
        })
      })
    );
  }
}
export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(withSuspensionBanners('landingpages-trusted')(ContentViewContainer));